import styled from 'styled-components'

export const Card = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.white,
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['12'],
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['12'],
  maxWidth: '40rem',
  padding: theme.space['20'],
  width: '100%',
}))
